import { useState, useEffect, useContext } from "react";
import { AppContext } from "app/appContext";
import { useLocation } from "react-router-dom";

// Custom hook to get page permissions
const usePagePermission = () => {
  const [permissions, setPermissions] = useState({
    canAdd: false,
    canView: false,
    canEdit: false,
    canDelete: false,
  });

  const findMenuPermissionByPath = (menuData, path) => {
    for (const menu of menuData) {
      if (menu.path == path) {
        return menu.permission;
      }

      if (menu.childMenus && menu.childMenus.length > 0) {
        const childPermission = findMenuPermissionByPath(menu.childMenus, path);
        if (childPermission) {
          return childPermission;
        }
      }
    }
  };

  // Access the user permissions context
  const userPermissions = useContext(AppContext); // Replace UserPermissionContext with the actual context you have
  const location = useLocation();

  useEffect(() => {
    // Here, you can set the permissions based on the context data
    if (userPermissions.navData) {
      const permission = findMenuPermissionByPath(
        userPermissions.navData,
        location.pathname
      );

      setPermissions({
        canView: permission?.canView ?? false,
        canAdd: permission?.canAdd ?? false,
        canEdit: permission?.canEdit ?? false,
        canDelete: permission?.canDelete ?? false,
      });
    }
  }, [userPermissions.navData]); // Add userPermissions to the dependency array to update the permissions when the context changes

  return permissions;
};

export default usePagePermission;
